<template>
  <layout-basic>
    <v-container grid-list-md text-xs-left fluid style="padding: 0px">
      <v-layout row wrap>
        <v-col cols="12" md="4"></v-col>
        <v-col cols="12" md="4">
          <v-card-text class="px-0">
            <h3>User Statistics</h3>
            <apexchart
              :options="lineChartOptions"
              :series="lineSeries"
              width="100%"
              type="line"
            />
          </v-card-text>
        </v-col>
        <v-col cols="12" md="4"></v-col>
      </v-layout>
      <v-container>
        <v-layout row wrap>
          <v-row style="justify-content: center;">
            <v-col cols="12" sm="6" md="3">
              <v-card
                class="text-xs-center px-0 mx-auto"
                height="100%"
                to="/super-admin/reports/partner1"
              >
                <v-card-text>
                  <v-img
                    width="120px"
                    height="120px"
                    position="center"
                    style="margin: 0 auto"
                    contain
                    src="/static/chart.png"
                  ></v-img>
                  <h3>{{$globalConfig.APP_NAME == 'senso' ? 'Level 1 Partners Reports' : 'Partners Reports'}}</h3>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="3" v-if="$globalConfig.APP_NAME == 'senso'">
              <v-card
                class="text-xs-center px-0 mx-auto"
                height="100%"
                to="/super-admin/reports/partner2"
              >
                <v-card-text>
                  <v-img
                    width="120px"
                    height="120px"
                    position="center"
                    style="margin: 0 auto"
                    contain
                    src="/static/chart.png"
                  ></v-img>
                  <h3>Level 2 Partner Reports</h3>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="3" v-if="$globalConfig.APP_NAME == 'senso'">
              <v-card
                class="text-xs-center px-0 mx-auto"
                height="100%"
                to="/super-admin/reports/customer"
              >
                <v-card-text>
                  <v-img
                    width="120px"
                    height="120px"
                    position="center"
                    style="margin: 0 auto"
                    contain
                    src="/static/chart.png"
                  ></v-img>
                  <h3>Customers Reports</h3>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-layout>
      </v-container>
    </v-container>
  </layout-basic>
</template>
<script>
import LayoutBasic from '@/layouts/SuperAdmin';
import VueApexCharts from 'vue-apexcharts';
import reportAPI from '@/api/superadmin.js';

export default {
  components: {
    LayoutBasic,
    apexchart: VueApexCharts,
  },
  data() {
    return {
      line: {},
      lineSeries: [
        {
          name: 'Logins',
          data: [0],
        },
      ],
      lineChartOptions: {
        chart: {
          height: 150,
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'straight',
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'],
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [1],
        },
      },
    };
  },
  mounted() {
    this.getReports();
  },
  computed: {
    lineChartY() {
      return this.line.logins.map((x) => {
        return x;
      });
    },
    lineChartX() {
      return this.line.months.map((x) => {
        return x;
      });
    },
  },
  methods: {
    lineChart() {
      this.lineChartOptions = {
        xaxis: {
          categories: this.lineChartX,
        },
        chart: {
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: false,
          zoom: false,
          zoomin: false,
          zoomout: false,
          pan: false,
          reset: false
            },
            export: {
              csv: {
                filename: `User_Statistics_SuperAdmin_${new Date().toISOString().slice(0, 19).replace(/[-T:]/g, "_")}`, // Custom filename with timestamp
                columnDelimiter: ",",
                headerCategory: "Month", // Custom X-axis title
                headerValue:  this.lineSeries[0].name, // Custom Y-axis title
              }
           }
          },
        },
      };
      this.lineSeries = [
        {
          data: this.lineChartY,
        },
      ];
    },
    getReports() {
      reportAPI.getReports().then((response) => {
        this.line = response.data.line;
        this.lineChart();
      });
    },
  },
};
</script>
